import React, {Component} from 'react';

import { Radio, Breadcrumb, Button, Modal, message } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import RestrictedSectorGrid from './RestrictedSectorGrid';
import RestrictedSectorEditDialog from './RestrictedSectorEditDialog';
import RadioOperationMode from '../../../../../utils/RadioOperationMode';
import '../../ComplianceRule.css';

const confirm = Modal.confirm;

class RestrictedSector extends Component {


  componentDidMount () {
    this.props.loadRestrictedSectors();
  }

  componentDidUpdate() {
    const { 
      batchDeleteRestrictedSectorActionStatus,
    } = this.props;
  
    // 批量删除 Restricted Sector 成功
    if (batchDeleteRestrictedSectorActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Restricted Sector are deleted successfully!');
      this.props.loadRestrictedSectors();
      this.props.initBatchDeleteRestrictedSectorActionStatus();
    }
      
    // 批量删除 Restricted Sector 失败
    if (batchDeleteRestrictedSectorActionStatus === ACTION_STATUS.ERROR) {
      message.success('Restricted Sector are deleted failed!');
      this.props.initBatchDeleteRestrictedSectorActionStatus();
    }
  }

  addButtonOnClicked = () => {
    this.props.openRestrictedSectorEditModalDialog(true, null);
  }

  editButtonOnClicked = () => {
    const {
      selectedRestrictedSectors
    } = this.props;

    if (selectedRestrictedSectors.length !== 1) {
      message.warning("Please select one restricted sector!");
      return;
    }

    this.props.openRestrictedSectorEditModalDialog(false, selectedRestrictedSectors[0]);
  }

  delButtonOnClicked = () => {
    const {
      selectedRestrictedSectors
    } = this.props;

    if (selectedRestrictedSectors.length === 0) {
      message.warning("Please select one restricted sector at least!");
      return;
    }

    let that = this;
    confirm({
      title: 'Are you sure you want to delete the restricted sector?',
      content: '',
      onOk() {
        const restrictedSectorIdList = selectedRestrictedSectors.map(restrictedSector => restrictedSector.id);

        that.props.batchDeleteRestrictedSector(restrictedSectorIdList);
      },
      onCancel() {},
    });
  }

  radioGroupOnChanged = (e) => {
    this.props.radioGroupChange(e.target.value);
  }

  render() {
    
    return (
      <div className="restrictedSectorWrapper">

        <div className='breadcrumbWrapper'>
          <Breadcrumb>
            <Breadcrumb.Item>Compliance Rule</Breadcrumb.Item>
            <Breadcrumb.Item>Restricted Sector</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        

        <div className='radioGroupWrapper'>
          <Radio.Group defaultValue="1" onChange={this.radioGroupOnChanged}>
            <Radio.Button value={RadioOperationMode.ALL}>All</Radio.Button>
            <Radio.Button value={RadioOperationMode.WHITE}>White List</Radio.Button>
            <Radio.Button value={RadioOperationMode.BLACK}>Black List</Radio.Button>
          </Radio.Group>
        </div>

        <div className='operationBar'>
          <Button 
            onClick={this.addButtonOnClicked} 
            size='small'
            className='positive-button'>
            Add
          </Button>

          <Button 
            onClick={this.editButtonOnClicked} 
            size='small'
            className='positive-button'>
            Edit
          </Button>

          <Button 
            onClick={this.delButtonOnClicked} 
            size='small'
            className='negative-button'>
            Del
          </Button>
        </div>

        <div className='restrictedSectorGrid'>
          <RestrictedSectorGrid {...this.props} />
        </div>

        <RestrictedSectorEditDialog {...this.props} />
      </div>
    );
  }
}

export default RestrictedSector;